import { getConfig } from '@edx/frontend-platform';
import { getAuthenticatedHttpClient, getAuthService } from '@edx/frontend-platform/auth';

// eslint-disable-next-line import/prefer-default-export
export async function patchAccount({ username, data }) {
  const requestConfig = {
    headers: { 'Content-Type': 'application/merge-patch+json' },
  };

  const authService = getAuthService();

  if (authService) {
    authService.getCsrfTokenService().clearCsrfTokenCache();
    await authService.getCsrfTokenService().getCsrfToken(getConfig().LMS_BASE_URL);
  }

  await getAuthenticatedHttpClient()
    .patch(
      `${getConfig().LMS_BASE_URL}/api/user/v1/accounts/${username}`,
      data,
      requestConfig,
    )
    .catch((error) => {
      throw (error);
    });
}
